import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../../handlers'

export const useAccountUserManagementMutation = () => {
  const godModeState = getGodModeOptionsState()

  return useGenericRequestHandler({
    route: 't/',
    method: 'POST',
    options: {
      json: godModeState.options,
      shouldNotStoreAuthData: godModeState.inGodMode
    }
  })
}
